import c0 from './bridge/notification_token_controller';
import c1 from './bridge/playback_listener_controller';
import c2 from './bridge/queue_listener_controller';
import c3 from './bridge/review_prompt_controller';
import c4 from './bridge/scroll_reveal_controller';
import c5 from './carousel_controller';
import c6 from './keyboard_viewport_controller';
import c7 from './poll_options_controller';
import c8 from './push_notifications_controller';
import c9 from './queue_state_controller';
import c10 from './queue_view_controller';
import c11 from './read_tracking_controller';
import c12 from './scroll_reveal_controller';
import c13 from './sticky_shadow_controller';
import c14 from './theater_controller';
import c15 from './thread_images_controller';
import c16 from './waveform_controller';
export const definitions = [
	{identifier: 'bridge--notification-token', controllerConstructor: c0},
	{identifier: 'bridge--playback-listener', controllerConstructor: c1},
	{identifier: 'bridge--queue-listener', controllerConstructor: c2},
	{identifier: 'bridge--review-prompt', controllerConstructor: c3},
	{identifier: 'bridge--scroll-reveal', controllerConstructor: c4},
	{identifier: 'carousel', controllerConstructor: c5},
	{identifier: 'keyboard-viewport', controllerConstructor: c6},
	{identifier: 'poll-options', controllerConstructor: c7},
	{identifier: 'push-notifications', controllerConstructor: c8},
	{identifier: 'queue-state', controllerConstructor: c9},
	{identifier: 'queue-view', controllerConstructor: c10},
	{identifier: 'read-tracking', controllerConstructor: c11},
	{identifier: 'scroll-reveal', controllerConstructor: c12},
	{identifier: 'sticky-shadow', controllerConstructor: c13},
	{identifier: 'theater', controllerConstructor: c14},
	{identifier: 'thread-images', controllerConstructor: c15},
	{identifier: 'waveform', controllerConstructor: c16},
];
